<template>
	<button
		:aria-current="isActive ? 'step' : undefined"
		class="text-subtitle-1 pa-4 text-uppercase amelipro-step-btn"
		:disabled="disabled"
		role="tab"
		:style="styles"
		type="button"
		v-on="$listeners"
		@blur="focused = false"
		@focus="focused = true"
	>
		<span class="d-flex align-center amelipro-step-btn__content">
			<slot />
		</span>
	</button>
</template>

<script setup lang="ts">
	import { computed, ref } from 'vue';
	import { IndexedObject } from '../../types';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		isActive: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	});

	const focused = ref(false);

	const styles = computed<IndexedObject>(() => {

		const btnStyles: IndexedObject = {
			backgroundColor: convertToHex('ap-blue lighten-3'),
			border: `1px solid ${convertToHex('ap-grey lighten-2')}`,
			color: convertToHex('ap-blue darken-1'),
			position: 'relative',
			zIndex: '1',
		};

		if (props.disabled && !props.isActive) {
			btnStyles.backgroundColor = convertToHex('ap-grey lighten-2');
			btnStyles.color = convertToHex('ap-grey darken-1');
			btnStyles.cursor = 'default';
		}

		if (props.isActive && !props.disabled) {
			btnStyles.backgroundColor = convertToHex('ap-blue darken-1');
			btnStyles.border = `1px solid ${convertToHex('ap-blue darken-1')}`;
			btnStyles.color = convertToHex('ap-white');
		}

		return btnStyles;
	});
</script>

<style lang="scss" scoped>
</style>
